<template>
    <b-row>
        <b-col v-if="VALIDATE_CABANG" cols="12" md="4">
            <b-form-group label="Cabang">
                <multiselect
                    name="cabang"
                    v-model="internalFilters.cabang" 
                    :options="optionsCabang" 
                    :internal-search="true"
                    :allow-empty="false"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="name"
                    placeholder="Cabang"
                />
            </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
            <b-form-group label="Tanggal">
                <b-form-input
                    v-model="internalFilters.date"
                    name="filterDate"
                    id="filterDate"
                    type="date"
                    class="flex-fill"
                ></b-form-input>
            </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
            <b-form-group label="Angka pertama Sojikyo">
                <b-form-select
                    v-model="internalFilters.sojikyoFirstNumber"
                    id="sojikyoFirstNumber"
                    name="sojikyoFirstNumber"
                    value-field="id"
                    text-field="name"
                    :options="optionsSojikyoFirstNumber"
                />
            </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
            <b-form-group label="Digit koma Sojikyo">
                <b-form-select
                    v-model="internalFilters.sojikyoDigitBehindComma"
                    id="sojikyoDigitBehindComma"
                    name="sojikyoDigitBehindComma"
                    value-field="id"
                    text-field="name"
                    :options="optionsSojikyoDigitBehindComma"
                />
            </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
            <b-form-group label="Hasil Timbang Sojikyo">
                <b-form-select
                    v-model="internalFilters.sojikyo"
                    id="filterSojikyo"
                    name="sojikyo"
                    value-field="id"
                    text-field="name"
                    :options="optionsSojikyo"
                />
            </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
            <b-form-group label="Hasil Timbang Pocket">
                <b-form-select
                    v-model="internalFilters.pocket"
                    id="filterPocket"
                    name="pocket"
                    value-field="id"
                    text-field="name"
                    :options="optionsPocket"
                />
            </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
            <b-form-group label="Kondisi Batu Uji">
                <b-form-select
                    v-model="internalFilters.batuUji"
                    id="filterBatuUji"
                    name="batuUji"
                    value-field="id"
                    text-field="name"
                    :options="optionsBatuUji"
                />
            </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
            <b-form-group label="Air Uji">
                <b-form-select
                    v-model="internalFilters.airUji"
                    id="filterAirUji"
                    name="airUji"
                    value-field="id"
                    text-field="name"
                    :options="optionsAirUji"
                />
            </b-form-group>
        </b-col>
        <b-col cols="12 mt-2">
            <div class="d-flex flex-wrap justify-content-between align-items-start" style="gap: 8px;">
                <div class="d-flex flex-wrap">
                    <b-button
                        variant="pgiBtn"
                        :disabled="isBusy"
                        class="mr-2 mb-2"
                        @click="$emit('onSearch')"
                    >
                        Search
                    </b-button>
                    <b-button
                        variant="pgiBtn"
                        :disabled="isBusy"
                        class="mb-2"
                        @click="$emit('onReset')"
                    >
                        Reset
                    </b-button>
                </div>

                <div class="wrapper-responsive-end">
                    <b-button v-if="IS_HAVE_PERMISSION_DOWNLOAD_EXCEL" variant="pgiBtn" @click="$emit('confirmDownloadExcel')">
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </b-button>
                    <b-button v-if="IS_HAVE_PERMISSION_ADD_CALIBRATION" variant="pgiBtn" @click="$emit('onShowModalAdd')">
                        <i class="fa fa-plus"></i> Tambah Kalibrasi
                    </b-button>
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'filter-kalibrasi',
    props: {
        filters: {
            type: Object,
            required: true,
        },
        IS_HAVE_PERMISSION_DOWNLOAD_EXCEL: {
            type: Boolean,
            default: false,
        },
        IS_HAVE_PERMISSION_ADD_CALIBRATION: {
            type: Boolean,
            default: false,
        },
        VALIDATE_CABANG: {
            type: Boolean,
            default: false,
        },
        isBusy: {
            type: Boolean,
            default: false,
        },
        optionsCabang: {
            type: Array,
            default: () => [],
        },
        optionsSojikyo: {
            type: Array,
            default: () => [],
        },
        optionsSojikyoFirstNumber: {
            type: Array,
            default: () => [],
        },
        optionsSojikyoDigitBehindComma: {
            type: Array,
            default: () => [],
        },
        optionsPocket: {
            type: Array,
            default: () => [],
        },
        optionsBatuUji: {
            type: Array,
            default: () => [],
        },
        optionsAirUji: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            internalFilters: { ...this.filters },
        }
    },
    watch: {
        internalFilters: {
            handler(newValue) {
                if (JSON.stringify(newValue) !== JSON.stringify(this.filters)) {
                    this.$emit("filterChanged", newValue);
                }
            },
            deep: true,
        },
        filters: {
            handler(newValue) {
                if (JSON.stringify(newValue) !== JSON.stringify(this.internalFilters)) {
                    this.internalFilters = newValue;
                }
            },
            deep: true,
        },
    }
}
</script>